import { Component, Input, OnInit } from '@angular/core';
import { WidgetComponent } from 'app/widget/widgets/widget-component';
import { StoreService } from 'core/services';
import { Subscription } from 'rxjs';
import { UtilsWidgetService } from '../services/utils-widget.service';

@Component({
  selector: 'lms-ratio-widget',
  templateUrl: './ratio-widget.component.html',
  styleUrls: ['./ratio-widget.component.scss']
})
export class RatioWidgetComponent implements WidgetComponent, OnInit {
  @Input() ratio: any;
  @Input() key?: string;
  @Input() data: any;

  private tooltipSubscription: Subscription = new Subscription();
  public tooltipText: string;

  constructor() {}

  ngOnInit() {
    this.tooltipSubscription = StoreService.get(this.data.action).subscribe((tooltipObject) => {
      this.tooltipText = UtilsWidgetService.containTooltip(tooltipObject, this.data.action, this.key);
    });
  }

  ngOnDestroy(): void {
    this.tooltipSubscription.unsubscribe();
  }
}
